import { TaxiCompanyApiTaxiCompanyUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiCompanyUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiCompanyApiTaxiCompanyUpdateRequest, config) =>
      appApiClient.taxiCompanyApi.taxiCompanyUpdate(req, config),
  });
